<template>
	<v-dialog
		v-model="showDialog"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		max-width="600px"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 資材への依頼 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<div class="mt-2">
					<table width="100%" class="show-dialog-table mt-4">
						<tbody>
							<tr>
								<th class="font-weight-bold" width="30%">項目名</th>
								<th class="font-weight-bold" width="30%">種類</th>
								<th class="font-weight-bold" width="40%">寸法・仕様</th>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<td>XXX</td>
								<td>XXXX</td>
								<td>XXXX</td>
							</tr>
						</tbody>
					</table>

					<table class="show-dialog-table mt-4" width="100%">
						<tbody>
							<ShowDetailRecord :columnName="'項目'">
								<template v-slot:value>
									<v-row no-gutters justify="space-between"
										><p>XXX</p>
										<p></p>
										<p>㎡</p></v-row
									>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
					<v-form ref="form" v-model="valid">
						<table class="show-dialog-table show-dialog-table--form mt-4" width="100%">
							<tbody>
								<ShowDetailRecord :columnName="'希望納期'">
									<template v-slot:value>
										<v-menu
											ref="menu"
											v-model="deadline"
											:close-on-content-click="false"
											transition="scale-transition"
											offset-y
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="deadline"
													:rules="[rules.required]"
													outlined
													dense
													readonly
													background-color="white"
													hide-details
													v-bind="attrs"
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="deadline" no-title scrollable locale="ja-JP">
											</v-date-picker>
										</v-menu>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'引当数量'">
									<template v-slot:value>
										<v-text-field
											v-model="quantity"
											:rules="[rules.required, rules.float]"
											outlined
											dense
											hide-details
											suffix="㎡"
											background-color="white"
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-form>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="createReservedComponents" :disabled="!valid">
							<v-icon class="mr-1">mdi-send</v-icon>
							依頼する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		type: {
			type: String,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			deleteDialog: false,
			deadline: null,
			quantity: null,
			valid: false,
			rules,
		}
	},
	methods: {
		createReservedComponents() {
			// TODO: 作成処理
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.$ref.form.reset()
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.border-right {
	border-right: 1px solid white;
}
</style>